import { Stack, Typography } from "@mui/material";
import React from "react";

const MyApp = () => {
  return (
    <>
      <Stack gap={1} alignItems={"center"}>
        <Typography variant="h1" color="initial">
        My apps
        </Typography>
        <Typography variant="body2" color="initial">
        Explore and adjust your app's settings to customize your experience.
        </Typography>
      </Stack>
    </>
  );
};

export default MyApp;
